import axiosInstance from "./AxiosInstance";

export function applypass(data) {
  return axiosInstance.post('api/employee/apply_pass', data);
}
export function changepass(data){
  return axiosInstance.post('api/employee/passchange_view',data)
}

export function getstoplist() {
  return axiosInstance.get('api/transport/search-stop');
}
export function getsearchroute(id) {
  return axiosInstance.get(`api/transport/search_route_stop/${id}`);
}
// export function getsearchshift(id) {
//   return axiosInstance.get(`api/transport/search-shift/${id}`);
// }
export function getschedule(stopId, shiftId) {
  return axiosInstance.get(`api/transport/search_schedule/${stopId}?shift=${shiftId}`);
}
export function passhistory() {
  return axiosInstance.get('api/employee/my_pass_history');
}

export function getPassLogListApi() {
  return axiosInstance.get('api/employee/my_pass_logs');
}
export function mypass() {
  return axiosInstance.get('api/employee/my_pass');
}
export function cancelpass(data) {
  return axiosInstance.post('api/employee/cancel_buss_pass', data)
}
export function addstop(data) {
  return axiosInstance.post('api/employee/stop-requests/', data);
}
export function boardinghistory() {
  return axiosInstance.get('api/employee/boarding_history')
}

export function getEmployeeTravelHistory(empId, param = {}) {
  const fparam = new URLSearchParams(param).toString()
  return axiosInstance.get(`api/transport/employee-boarding-log/${empId}?${fparam}`)
}
export function changeEmployeeStatusAapi(eid,data){
  return axiosInstance.patch(`api/transport/employees/${eid}/status/`,data)
}

export function getEmployeePassLog(empId, param = {}) {
  const fparam = new URLSearchParams(param).toString()
  return axiosInstance.get(`api/transport/employee_pass_log/${empId}?${fparam}`)
}


export const getAdminPassRequests = () => {
  return axiosInstance.get("/api/employee/pass-requests/");
};

export const updatePassRequestStatus = (id, status) => {
  return axiosInstance.patch(`/api/employee/pass-requests/${id}/`, {
    request_status: status,
  });
};

